import { render, staticRenderFns } from "./InitPurchaseAuth.vue?vue&type=template&id=c9d06516&scoped=true"
import script from "./InitPurchaseAuth.vue?vue&type=script&lang=js"
export * from "./InitPurchaseAuth.vue?vue&type=script&lang=js"
import style0 from "./InitPurchaseAuth.vue?vue&type=style&index=0&id=c9d06516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d06516",
  null
  
)

export default component.exports